import { Component, OnInit, Inject } from '@angular/core';
import {MD_DIALOG_DATA} from '@angular/material';
import {MdDialog, MdDialogRef} from '@angular/material';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';

@Component({
  selector: 'app-edit-subcategory',
  templateUrl: './edit-subcategory.component.html',
  styleUrls: ['./edit-subcategory.component.css']
})
export class EditSubcategoryComponent implements OnInit {
	complexForm : FormGroup;

  constructor(@Inject(MD_DIALOG_DATA) public data: any, public dialogRef: MdDialogRef <EditSubcategoryComponent>, fb: FormBuilder) { 
  		this.complexForm = fb.group({
	      // To add a validator, we must first convert the string value into an array. The first item in the array is the default value if any, then the next item in the array is the validator. Here we are adding a required validator meaning that the firstName attribute must have a value in it.
	      // We can use more than one validator per field. If we want to use more than one validator we have to wrap our array of validators with a Validators.compose function. Here we are using a required, minimum length and maximum length validator.
	      'subcategoryName': [null, Validators.compose([Validators.required, Validators.minLength(2), this.NoWhitespaceValidator, this.AlphanumericValidator])],
	    })
	}

  ngOnInit() {
  	console.log(this.data);
  	this.complexForm.setValue({
      'subcategoryName': this.data.subcategoryName
    }) 
  }

    saveData() {
    	// console.log(this.complexForm.value.subcategoryName);
	    this.dialogRef.close(this.complexForm.value.subcategoryName);
	}

  public NoWhitespaceValidator(control: FormControl) {
		if (/\s/.test(control.value)) {
		    // It has any kind of whitespace
		    return { 'whitespace': true };
		}
		else{
			return null;
		}
	}

	public AlphanumericValidator(control: FormControl) {
		if (/^[\w\-\s]+$/.test(control.value)) {
		    // It contains other characters than letters and numbers
		    return null;
		}
		else{
			return { 'alphanumeric': true };
		}
	}


}



// WEBPACK FOOTER //
// d:/xampp/htdocs/zenith-admin/src/app/edit-subcategory/edit-subcategory.component.ts